import { render, staticRenderFns } from "./InicioDetalhesModal.vue?vue&type=template&id=4e5f8681&scoped=true&"
import script from "./InicioDetalhesModal.vue?vue&type=script&lang=js&"
export * from "./InicioDetalhesModal.vue?vue&type=script&lang=js&"
import style0 from "./InicioDetalhesModal.vue?vue&type=style&index=0&id=4e5f8681&scoped=true&lang=css&"
import style1 from "./InicioDetalhesModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f8681",
  null
  
)

export default component.exports